<template>
  <div class="card mb-3">
    <div class="card-body cg-tight">
      <div
        class="d-flex justify-content-between align-items-baseline flex-wrap gap-2"
      >
        <h3 class="cg-card-title">Buffer</h3>
        <button type="button" class="btn btn-sm btn-outline-secondary ms-auto">
          Manage buffer
        </button>
      </div>
      <div class="cg-half cg-rule-top cg-halves-gap">
        <p class="cg-micro mb-2">Certificates not allocated to a portfolio</p>
        <StatBlock :value="fmt(buffer)" unit="MWh in buffer" class="mb-2" />
        <StackedBar
          :segments="[{ fill: 'expected', pct: '100%' }]"
          :height="15"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { fmt } from "@/compliance_groups/fixture/format";
import StackedBar from "./StackedBar.vue";
import StatBlock from "./StatBlock.vue";

defineProps<{ buffer: number }>();
</script>

<style scoped lang="scss">
.cg-half {
  flex: 1 1 220px;
  min-width: 0;
}
</style>
